import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'cesium/Build/Cesium/Widgets/widgets.css'

import App from './App.vue'
import router from './router'
import './styles/global.scss'
import { installFrontendLogging } from './utils/logger'

installFrontendLogging()
createApp(App).use(createPinia()).use(router).use(ElementPlus).mount('#app')
